export const environment = {   production: true,   apiUrl: "https://api-basic.edujob.com.br",   professionalAPIURL: "https://api.edujob.com.br" };
